import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";

interface Props {
  children: React.ReactNode;
  ariaLabel?: string;
  onClick: () => void;
  color?: string;
  hoverColor?: string;
  className?: string;
}

export const LinkButton: React.FC<Props> = (props) => {
  const { children, ariaLabel, onClick, color, hoverColor, className } = props;

  return (
    <StyledButton
      role="button"
      aria-label={ariaLabel}
      onClick={onClick}
      $color={color}
      $hoverColor={hoverColor}
      className={className}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.div<{ $color?: string; $hoverColor?: string }>`
  cursor: pointer;
  display: inline-block;
  text-decoration: underline;
  color: ${({ $color }) => $color || color.blue[400]};
  &:hover {
    color: ${({ $hoverColor }) => $hoverColor || color.blue[500]};
  }
`;
